(ns cljss.reagent
  (:require [cljss.core :refer-macros [make-styled]]))

(make-styled)
